import Character from "./character";

export default Character;
